import { supabase } from '../supabase'

export const reviewsService = {
  // Crear o actualizar review
  async crearReview(userId, tipoEntidad, idEntidad, estrellas, titulo, textoReview = '', metadata = {}) {
    const { data, error } = await supabase
      .from('reviews')
      .upsert({
        user_id: userId,
        entity_type: tipoEntidad,
        entity_id: idEntidad,
        rating: estrellas,
        title: titulo,
        content: textoReview,
        entity_name: metadata.name || null,
        entity_artist: metadata.artist || null,
        entity_album: metadata.album || null,
        entity_image: metadata.image || null,
        updated_at: new Date().toISOString()
      }, {
        onConflict: 'user_id,entity_type,entity_id'
      })
      .select()
    if (error) throw error
    return data[0]
  },

  // Obtener todos los reviews de una entidad CON USERNAMES
  async obtenerReviewsDeEntidad(tipoEntidad, idEntidad) {
    const { data, error } = await supabase
      .from('reviews')
      .select(`
        *,
        users:user_id (
          username,
          email,
          avatar_url
        )
      `)
      .eq('entity_type', tipoEntidad)
      .eq('entity_id', idEntidad)
      .order('created_at', { ascending: false })

    if (error) throw error
    return data
  },

  // Calcular promedio de estrellas
  async obtenerPromedioEstrellas(tipoEntidad, idEntidad) {
    const { data, error } = await supabase
      .from('reviews')
      .select('rating')
      .eq('entity_type', tipoEntidad)
      .eq('entity_id', idEntidad)
      .not('rating', 'is', null)
    
    if (error) throw error
    
    if (data.length === 0) return { promedio: 0, total: 0 }
    
    const promedio = data.reduce((suma, r) => suma + r.rating, 0) / data.length
    return { promedio: Math.round(promedio * 10) / 10, total: data.length }
  },

  // Obtener todos los reviews de un usuario
  async obtenerReviewsDeUsuario(userId) {
    const { data, error } = await supabase
      .from('reviews')
      .select('*')
      .eq('user_id', userId)
      .order('created_at', { ascending: false })
    
    if (error) throw error
    return data
  },

  // Ver si un usuario ya calificó algo
  async obtenerReviewDeUsuario(userId, tipoEntidad, idEntidad) {
    const { data, error } = await supabase
      .from('reviews')
      .select('*')
      .eq('user_id', userId)
      .eq('entity_type', tipoEntidad)
      .eq('entity_id', idEntidad)
      .single()
    
    if (error && error.code !== 'PGRST116') throw error
    return data
  },

  // Obtener todos los reviews de todas las canciones
  async obtenerTodosLosReviews() {
    const { data, error } = await supabase
      .from('reviews')
      .select('*')
      .order('created_at', { ascending: false })
    
    if (error) throw error
    return data
  }
}